import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

interface Props {
  loading: boolean;
  colors: {
    PRIMARY: string;
    ACCENT: string;
    NEUTRAL: string;
    SECONDARY: string[];
  };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  props: {
    loading: { type: Boolean },
    colors: {}
  },
  emits: ["login"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "fill-height"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        align: "center",
        justify: "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "8",
            md: "4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { class: "elevation-12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "text-center pt-6" }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createElementVNode("h2", null, "1stopVAT Walmart Portal", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, { class: "text-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        color: _ctx.colors.PRIMARY,
                        size: "large",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('login'))),
                        loading: _ctx.loading
                      }, {
                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                          _createTextVNode(" Login with Microsoft ")
                        ])),
                        _: 1
                      }, 8, ["color", "loading"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})